module.exports = __webpack_public_path__ + "static/media/B&TScreenshot7.99048483.png";